class QuantityRange extends HTMLElement {
  connectedCallback(){
    console.log('this->>>>>>>>>>', this)
    this.input = this.querySelector('[data-quantity-input]');
    this.plus = this.querySelector('[data-quantity-plus]');
    this.minus = this.querySelector('[data-quantity-minus]');
    this.mainWrapper = this.closest('[data-product-details]');
    this.rangeInput = this.querySelector("#rangeInput");
    setTimeout(() => {
      this.rangeInput.value = 1;
      this.input.value = 1;
    },1700)

    window.addEventListener('load', () => {
      setTimeout(() => {
        if (sc_gqbreak_app_global && sc_gqbreak_app_global.curr_qb_price_tiers) {
          this.classList.add('discount-range--enabled');
          // this.mainWrapper.querySelector('.range-quantity').style.display = 'block';
          this.rangeInput.disabled = false;
        }
      }, 1000);
    });

    this.init();
  }

  init(){
    var loadOptionVal;
    var variantSelection = this.mainWrapper.querySelector('.variant-selection');
    var hasOnlyDefaultVariant = variantSelection.querySelector('.variant-selection__variants--default');
    
    if (hasOnlyDefaultVariant) {
      loadOptionVal = hasOnlyDefaultVariant.getAttribute('data-quantity');
    } else {
      var selectElement = variantSelection.querySelector('.variant-selection__variants');
      var selectedOption = selectElement.options[selectElement.selectedIndex];
      loadOptionVal = selectedOption.getAttribute('data-quantity');
    }

    var optionVal = loadOptionVal;

    let updateRange = () => {
      console.log("updateRange")
      var rangeVal = this.rangeInput.value;
      var mainQuantitySelector = this.input;
      mainQuantitySelector.value = rangeVal;
      mainQuantitySelector.dispatchEvent(new Event('change'));
      this.input.value = rangeVal;
      // document.dispatchEvent(new Event('input'));
      // document.querySelector('.quantity-selector__input').value = rangeVal;
      // document.dispatchEvent(new Event('input'));
      var maxValue = parseInt(this.rangeInput.max);
      var currentValue = parseInt(this.rangeInput.value);
      var mainValue = (100 / maxValue) * currentValue;
      this.querySelector('.range-background').style.width = mainValue + '%';
      this.querySelector('[data-button-wrapper-plus]').classList.toggle('quantity-selector__button-wrapper--disabled',(mainValue == 100))
      this.updatePrice();
      
    }
    this.rangeInput.addEventListener('input', updateRange);

    this.plus.addEventListener('click', () => {
      setTimeout(() => {
        this.input.dispatchEvent(new Event('input'));
        updateRange();
      }, 50);
    });
    
    this.minus.addEventListener('click', () => {
      setTimeout(() => {
        this.input.dispatchEvent(new Event('input'));
        updateRange();
      }, 50);
    });
    
    this.input.addEventListener('input', () => {
      var rangeEle = this.rangeInput;
      rangeEle.value = this.input.value;
      var maxValue = parseInt(rangeEle.max);
      var currentValue = parseInt(rangeEle.value);
      var mainValue = (100 / maxValue) * currentValue;
      document.querySelector('.range-background').style.width = mainValue + '%';
      this.updatePrice();
    });
  }

  updatePrice(){
    var data_price;
    var variantSelection = document.querySelector('.variant-selection');
    var hasOnlyDefaultVariant = variantSelection.querySelector('.variant-selection__variants--default');
    const inputQuantity = this.rangeInput.value;
    const discountQTY = inputQuantity;
    let data_compare_price = 0;
    
    if (hasOnlyDefaultVariant) {
      data_price = hasOnlyDefaultVariant.getAttribute('data-price');
      data_compare_price = hasOnlyDefaultVariant.getAttribute('data-compareprice');
    } else {
      var selectElement = variantSelection.querySelector('.variant-selection__variants');
      var selectedOption = selectElement.options[selectElement.selectedIndex];
      data_price = selectedOption.getAttribute('data-price');
      data_compare_price = selectedOption.getAttribute('data-compareprice');
    }
    const dataPrice = data_price;
    const priceByQuantity = dataPrice * discountQTY;
    const dataComparePrice = data_compare_price;
    const comparePriceByQuantity = dataComparePrice * discountQTY;
    const discountedPrice = comparePriceByQuantity - priceByQuantity;
    
    
    if (document.querySelector('.quantity-selector__input')) {
      const quantityNumVal = document.querySelector('.quantity-selector__input').value;
      const quantityNumMax = document.querySelector('.quantity-selector__input').max;
      // const quantityNumVal = event.target.value;
      // const quantityNumMax = event.target.max;
      const mainQuantitySelector = document.querySelector('.quantity-selector .quantity-selector__input');
  
      if (quantityNumVal > parseInt(quantityNumMax)) {
        event.target.value = quantityNumMax;
        mainQuantitySelector.value = quantityNumMax;
        // mainQuantitySelector.dispatchEvent(new Event('change'));
        this.rangeInput.value = quantityNumMax;
      } else if (quantityNumVal == '') {
        // ...
      } else {
        this.rangeInput.value = quantityNumVal;
        mainQuantitySelector.value = quantityNumVal;
        // mainQuantitySelector.dispatchEvent(new Event('change'));
      }
  
      // const maxValue = parseInt(event.target.max);
      // const currentValue = parseInt(event.target.value);
      const maxValue = parseInt(document.querySelector('.quantity-selector__input').max);
      const currentValue = parseInt(document.querySelector('.quantity-selector__input').value);
      const mainValue = (100 / maxValue) * currentValue;
      document.querySelector('.range-background').style.width = mainValue + '%';

      
      const inputQuantity = this.rangeInput.value;
      // const inputQuantity = event.target.value;
      const discountQTY = inputQuantity;
  
      let appDiscounts = sc_gqbreak_app_global.curr_qb_price_tiers;
      let productDiscountTire = null;
      for (let index = 0; index < appDiscounts.length; index++) {
        let discountObj = appDiscounts[index];
        if (parseInt(discountQTY) < parseInt(discountObj.quantity)) {
          productDiscountTire = appDiscounts[(index - 1)];
          break;
        }
      }
  
      if (productDiscountTire == null) {
        productDiscountTire = appDiscounts[appDiscounts.length - 1];
      }
  
      const appdiscount = productDiscountTire.percent_discount;
      const customappPriceByQuantity = (priceByQuantity / 100) * appdiscount;
      const customappDiscountedPrice = priceByQuantity - customappPriceByQuantity;
  
      const Appdiscountpricewithoutdeciam = parseInt(productDiscountTire.price * 100);
      let apppricebyqty = Appdiscountpricewithoutdeciam * discountQTY;

      let orgPriceByQuantity = window.Shopify.formatMoney(priceByQuantity, window.Theme.settings.moneyFormat); 
      let customappFormatdiscountprice = window.Shopify.formatMoney(apppricebyqty, window.Theme.settings.moneyFormat); 
      
  
      if (appdiscount == 0) {
        apppricebyqty = 0;
      }else{
        orgPriceByQuantity = window.Shopify.formatMoney(apppricebyqty, window.Theme.settings.moneyFormat); ;
        customappFormatdiscountprice = window.Shopify.formatMoney(priceByQuantity, window.Theme.settings.moneyFormat); ;
      }
      
      
      document.querySelector('.product-pricing').querySelector('[data-product-price]').innerHTML = orgPriceByQuantity;
      
      this.mainWrapper.querySelector('[data-price-compare]').innerHTML = customappFormatdiscountprice;
      this.mainWrapper.querySelector('[data-price-compare-container]').classList.toggle('visible',!(apppricebyqty == 0));


      /*if (document.querySelector('.docapp-volume-discounts-promo-table-item')) {
        discountTable(discountQTY);
      } 
      else if (document.querySelector('.docapp-volume-discounts-promo-line')) {
        discountLine(discountQTY);
      } 
      else {
        const dataPrice = data_price;
        const priceByQuantity = dataPrice * discountQTY;
        const dataComparePrice = data_compare_price;
        const comparePriceByQuantity = dataComparePrice * discountQTY;
        const discountedPrice = comparePriceByQuantity - priceByQuantity;
  
        
        // const orgDiscountedPrice = window.Shopify.formatMoney(comparePriceByQuantity, window.Theme.settings.moneyFormat); 
        // document.querySelector('.product-pricing').querySelector('.price__compare-at .price__compare-at--single').innerHTML = orgDiscountedPrice;
        // const orgSavingPrice = window.Shopify.formatMoney(discountedPrice, window.Theme.settings.moneyFormat); 
        // document.querySelector('.product-pricing').querySelector('.product__price-savings').innerHTML = 'Ahorra ' + orgSavingPrice;
      }*/
      
    }
  }

  createRenge(optionVal) {
    var optionValString = optionVal.toString();
    if (optionValString.indexOf('-') > -1) {
        document.querySelector('.quantity-selector').style.display = 'block';
        document.querySelector('.range-quantity').style.display = 'none';
        // document.querySelector('.saving-arrow').classList.add('hide');
    } 
    else {
      if (optionVal > 5) {
          document.querySelector('.quantity-selector').style.display = 'block';
          document.querySelector('.range-quantity').style.display = 'block';
          document.querySelector('#rangeInput').setAttribute('max', parseInt(optionVal));
          document.querySelector('.quantity-selector__input').setAttribute('max', parseInt(optionVal));
          var oneOfFive = parseInt(optionVal) / 5;
          var roundOneOfFive = Math.round(oneOfFive);
          var starTVal = 0;
          var optionLength = document.querySelectorAll('#tickmarks .tickmarksOpt').length;

          document.querySelectorAll('#tickmarks .tickmarksOpt').forEach(function (element, index) {
              starTVal = starTVal + roundOneOfFive;
              if (index == optionLength - 1) {
                  element.textContent = parseInt(optionVal);
              } 
              else {
                element.textContent = starTVal;
              }
          });
          // document.querySelector('.saving-arrow').classList.remove('hide');
      } 
      else {
        document.querySelector('.quantity-selector').style.display = 'block';
        document.querySelector('.range-quantity').style.display = 'none';
        // document.querySelector('.saving-arrow').classList.add('hide');
      }
    }
  }
}
customElements.define('quantity-range', QuantityRange);

  document.addEventListener('DOMContentLoaded', () => {
    const h2 = document.querySelector('#revieList h2');
    if (h2) {
      const p = document.createElement('p');
      p.classList.add('title_reseñas');
      p.textContent = 'Reseñas';
      h2.replaceWith(p);
    }
  });